import React, { PureComponent } from 'react';

/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { getLanguage } from '@atlassian/bitkit-code';

import { ConnectModulesState } from 'src/connect';
import { ConnectFileEditor } from 'src/connect/file-modules';

import SelectedLineProvider from '../containers/selected-line-provider';
import { FileEditorMode } from '../types';

import { MonacoFile } from './monaco-file';

const ConnectFileEditorWrapper = styled.div<{ isHidden: boolean }>(props => ({
  display: props.isHidden ? 'none' : 'block',
}));

type Props = {
  connectEditorModuleKey?: string;
  contents: string;
  fileEditorMode: FileEditorMode;
  height: string;
  onChange: (value: string) => void;
  onConnectMountOrUpdate: (state: ConnectModulesState) => void;
  onEditCancel: () => void;
  path: string;
  supportsConnectEditor: boolean;
};

export default class EditableFileContents extends PureComponent<Props> {
  static defaultProps = {
    /* eslint react/default-props-match-prop-types: "warn" */
    onChange: () => {},
    onEditCancel: () => {},
    onConnectMountOrUpdate: () => {},
  };

  render() {
    const {
      connectEditorModuleKey,
      contents,
      fileEditorMode,
      height,
      path,
      supportsConnectEditor,
    } = this.props;

    const filename = path.split('/').pop();
    const language = filename ? getLanguage(filename) : null;

    const isConnectEditorHidden =
      fileEditorMode === 'editor-diff' || fileEditorMode === 'editor-preview';
    const isMonacoHidden =
      (fileEditorMode === 'editor' && supportsConnectEditor) ||
      fileEditorMode === 'editor-diff' ||
      fileEditorMode === 'editor-preview';

    const defaultFileViewer = (
      <SelectedLineProvider
        path={path}
        // @ts-ignore TODO: fix noImplicitAny error here
        render={({ handleLineNumClick, selectedRanges }) => (
          // @ts-ignore Missing some props?
          <MonacoFile
            filename={filename || ''}
            height={height}
            // Keep in read-only mode even when editing (for performance) if a Connect file editor is active
            isEditing={fileEditorMode !== 'read-only' && !supportsConnectEditor}
            isHidden={isMonacoHidden}
            language={language ? language.monaco : undefined}
            onChange={this.props.onChange}
            onLineNumClick={handleLineNumClick}
            selectedRanges={selectedRanges}
            value={contents}
          />
        )}
      />
    );

    if (fileEditorMode === 'read-only') {
      return defaultFileViewer;
    }

    return (
      <React.Fragment>
        {defaultFileViewer}
        {supportsConnectEditor && (
          <ConnectFileEditorWrapper isHidden={isConnectEditorHidden}>
            <ConnectFileEditor
              source={contents}
              height={height}
              moduleKey={connectEditorModuleKey}
              onChange={this.props.onChange}
              onMount={this.props.onConnectMountOrUpdate}
              onReset={this.props.onEditCancel}
              onUpdate={this.props.onConnectMountOrUpdate}
              path={path}
            />
          </ConnectFileEditorWrapper>
        )}
      </React.Fragment>
    );
  }
}
